import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Login = () => import(/* webpackChunkName: "auth" */ '../views/Login.vue')
const Register = () => import(/* webpackChunkName: "auth" */ '../views/Register.vue')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
const MobileDashboard = () => import(/* webpackChunkName: "dashboard" */ '../views/MobileDashboard.vue')
const JpTagScorePage = () => import(/* webpackChunkName: "add-tag" */ '../views/JpTagScorePage.vue')

const routes = [
  { path: '/member-bookings', name: 'MemberBookings', component: Dashboard, meta: { active: 'member-bookings' } },
  { path: '/member-card', name: 'NetCardPreview', component: Dashboard, meta: { active: 'member-card' } },
  { path: '/card-render', name: 'NetCardRender', component: () => import('../views/NetCardRender.vue'), meta: { public: true, allowAuthed: true } },
  { path: '/member-rewards', name: 'MemberRewards', component: Dashboard, meta: { active: 'member-rewards' } },
  { path: '/business-management', name: 'BusinessManagement', redirect: '/store-management?tab=business' },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { public: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "auth" */ '../views/ForgotPassword.vue'),
    meta: { public: true, allowAuthed: true }
  },
  {
    path: '/add-tag',
    name: 'AddTag',
    component: JpTagScorePage,
    meta: { public: true, allowAuthed: true }
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Dashboard,
    meta: { active: 'home' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Dashboard,
    meta: { active: 'profile' }
  },
  {
    path: '/my-store',
    name: 'MyStore',
    component: Dashboard,
    meta: { active: 'my-store' }
  },
  {
    path: '/store-dashboard',
    name: 'StoreDashboard',
    component: Dashboard,
    meta: { active: 'store-dashboard' }
  },
  {
    path: '/store-management',
    name: 'StoreManagement',
    component: Dashboard,
    meta: { active: 'store-management' }
  },
  {
    path: '/store-members',
    name: 'StoreMembers',
    component: Dashboard,
    meta: { active: 'store-members' }
  },
  {
    path: '/store-pricing',
    name: 'StorePricing',
    component: Dashboard,
    meta: { active: 'store-pricing' }
  },
  {
    path: '/store-consumptions',
    name: 'StoreConsumptions',
    component: Dashboard,
    meta: { active: 'store-consumptions' }
  },
  {
    path: '/store-payments',
    name: 'StorePayments',
    component: Dashboard,
    meta: { active: 'store-payments' }
  },
  {
    path: '/judge-machines',
    name: 'JudgeMachines',
    component: Dashboard,
    meta: { active: 'judge-machines' }
  },
  {
    path: '/machine-binding',
    name: 'MachineBinding',
    component: Dashboard,
    meta: { active: 'machine-binding' }
  },
  {
    path: '/m',
    name: 'MobileDashboard',
    component: MobileDashboard
  },
  {
    path: '/chart-center',
    name: 'ChartCenter',
    component: Dashboard,
    meta: { active: 'chart-center' }
  },
  {
    path: '/ipad-resources',
    name: 'IpadResources',
    component: Dashboard,
    meta: { active: 'ipad-resources' }
  },
  {
    path: '/song-search',
    name: 'SongSearch',
    component: Dashboard,
    meta: { active: 'song-search' }
  },
  {
    path: '/score-query',
    name: 'ScoreQuery',
    component: Dashboard,
    meta: { active: 'score-query' }
  },
  {
    path: '/score-images',
    name: 'ScoreImages',
    component: Dashboard,
    meta: { active: 'score-images' }
  },
  {
    path: '/collection-search',
    name: 'CollectionSearch',
    component: Dashboard,
    meta: { active: 'collection-search' }
  },
  {
    path: '/map-search',
    name: 'MapSearch',
    component: Dashboard,
    meta: { active: 'map-search' }
  },
  {
    path: '/data-protection',
    name: 'DataProtection',
    component: Dashboard,
    meta: { active: 'data-protection' }
  },
  {
    path: '/admin-stats',
    name: 'AdminStats',
    component: Dashboard,
    meta: { active: 'admin-stats' }
  },
  {
    path: '/admin-users',
    name: 'AdminUsers',
    component: Dashboard,
    meta: { active: 'admin-users' }
  },
  {
    path: '/announcements',
    name: 'Announcements',
    component: Dashboard,
    meta: { active: 'announcements' }
  },
  {
    path: '/roles',
    name: 'Roles',
    component: Dashboard,
    meta: { active: 'roles' }
  },
  {
    path: '/redeem-codes',
    name: 'RedeemCodes',
    component: Dashboard,
    meta: { active: 'redeem-codes' }
  },
  {
    path: '/tag-management',
    name: 'TagManagement',
    component: Dashboard,
    meta: { active: 'tag-management' }
  },
  {
    path: '/page-features',
    name: 'PageFeatures',
    component: Dashboard,
    meta: { active: 'page-features' }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/profile' && to.query.botGroups === '1') {
    next({ path: '/store-management', query: { ...to.query, tab: 'bot' }, hash: to.hash, replace: true })
    return
  }
  const token = localStorage.getItem('token')
  const isPublic = !!(to.meta && to.meta.public)
  if (!isPublic && !token) {
    next({
      name: 'Login',
      query: to.fullPath && to.fullPath !== '/' ? { redirect: to.fullPath } : undefined
    })
    return
  }
  if (isPublic && token && !(to.meta && to.meta.allowAuthed)) {
    next({ name: 'Home' })
    return
  }
  next()
})

export default router
